import { gql } from '@apollo/client'

export default gql(`
    mutation triggerFasterSync($action: String $project: String $match: MatchInput ) {
        triggerFasterSync(
            input: {
                action: $action
                match: $match
            }
            project: $project
        ) {
            id
            status
        }
    }`
)
